"use client";

import React from "react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer id="relume" className="bg-gray-900 px-[5%] py-12 md:py-18 lg:py-20">
      <div className="container">
        <div className="grid grid-cols-1 gap-x-[4vw] gap-y-12 pb-12 md:gap-y-16 md:pb-18 lg:grid-cols-[1fr_0.5fr] lg:gap-y-4 lg:pb-20">
          <div>
            
            <div className="mb-6 md:mb-8">
              <p className="mb-1 text-sm font-semibold text-white">Address:</p>
              <p className="mb-5 text-sm text-gray-300 md:mb-6">
                Omnigeist LLC<br />
                7969 NW 2nd Street #1377<br />
                Miami, FL 33126<br />
                United States
              </p>
              <p className="mb-1 text-sm font-semibold text-white">Contact:</p>
              <a
                href="mailto:info@omnigeist.com"
                className="block text-sm text-gray-300 underline decoration-gray-300 underline-offset-1 hover:text-white"
              >
                info@omnigeist.com
              </a>
            </div>
          </div>
          <div className="grid grid-cols-1 items-start gap-x-6 gap-y-10 md:grid-cols-2 md:gap-x-8 md:gap-y-4">
            <div>
              <h3 className="mb-4 text-sm font-semibold text-white">AI Tools & Platforms</h3>
              <ul>
                <li className="py-2 text-sm font-semibold">
                  <a href="https://codeium.com/windsurf" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Windsurf IDE</a>
                </li>
                <li className="py-2 text-sm font-semibold">
                  <a href="https://www.cursor.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Cursor Editor</a>
                </li>
                <li className="py-2 text-sm font-semibold">
                  <a href="https://claude.ai/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Claude AI</a>
                </li>
                <li className="py-2 text-sm font-semibold">
                  <a href="https://chatgpt.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">ChatGPT</a>
                </li>
                <li className="py-2 text-sm font-semibold">
                  <a href="https://n8n.io/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">n8n</a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="mb-4 text-sm font-semibold text-white">Development Resources</h3>
              <ul>
                <li className="py-2 text-sm font-semibold">
                  <a href="https://aistudio.google.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Google AI Studio</a>
                </li>
                <li className="py-2 text-sm font-semibold">
                  <a href="http://relume.io/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Relume.io</a>
                </li>
                <li className="py-2 text-sm font-semibold">
                  <a href="https://github.com/microsoft/semantic-kernel" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Semantic Kernel</a>
                </li>
                <li className="py-2 text-sm font-semibold">
                  <a href="https://github.com/lllyasviel/Fooocus" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Fooocus</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="h-px w-full bg-gray-800" />
        <div className="flex flex-col items-center justify-between gap-y-4 pt-8 md:flex-row md:pt-12 lg:pt-14">
          <div className="text-center text-sm md:text-left group">
            <div className="text-gray-300 cursor-help">
              &copy; {new Date().getFullYear()} Omnigeist. All rights reserved.
            </div>
            <div 
              className="hidden group-hover:block mt-1"
            >
              <Link 
                to="/l33t" 
                className="text-[#39ff14] font-mono hover:underline inline-block glitch-reveal"
                style={{
                  textShadow: '0 0 5px #39ff14, 0 0 10px #39ff14',
                }}
              >
                &gt;&gt; SYSTEM_BREACH_DETECTED &lt;&lt;
              </Link>
            </div>
          </div>
          <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 text-center text-sm text-gray-300 md:justify-start">
            <Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-white">Terms of Service</Link>
            <Link to="/cookie-policy" className="hover:text-white">Cookie Policy</Link>
            <a href="/llms.txt" className="hover:text-white">llms.txt</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
